"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("@turajs/util");
const convertContractData_1 = require("./internal/convertContractData");
const countDataPages_1 = require("./countDataPages");
exports.generateDataStack = (data) => {
    const dataHex = data
        .map(convertContractData_1.convertContractData)
        .map(long => util_1.convertDecStringToHexString(long, 16))
        .map(util_1.convertHexEndianess)
        .join('');
    const dataPageCount = countDataPages_1.countDataPages(dataHex);
    return {
        dataHex,
        dataPageCount
    };
};
//# sourceMappingURL=generateDataStack.js.map